import script from "./KC.vue?vue&type=script&lang=js"
export * from "./KC.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__